import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../Vas';

import '../css/VerificationReupload.css';

import { DateTimeHelper,CheckValues } from 'utils-lib';

import { ExtendedButton,TextField,Icon,SelectField,DateField,MessageBox } from 'component-lib';
import {ConfirmationsModel, RequestAjaxClass} from 'models-lib';

var moment = require('moment');
moment().format();

class VerificationReupload extends Component
{
  constructor(props)
  {
      super(props);
      this.state = {};
      this.state.existConfirm = [];
      this.state.Files = [];

      this.FileText = React.createRef();
      this.VerificationMonthRef = React.createRef();
      this.UploadCertificateRef = React.createRef();

      this.updloadedFiles = 0;
      this.filesCount = 0;
      this.filesCountCur = 0;

      this.state.ConfirmationsRequired = false;
      this.state.CustomerOfAge = true;

      this.IconConfig = Vas.Config.ShowIconsOrButtons;
      this.UploadConfig = Vas.Config.DocumentUpload;

      this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
      this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
      this.Request3 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

      this.ConfirmationsModel = new ConfirmationsModel([this],null,this.Request);
      this.ExistingConfirmationsModel = new ConfirmationsModel([this],null,this.Request2);
      this.UploadingConfirmationsModel = new ConfirmationsModel([this],null,this.Request3);

    //Prüfung wenn localStorage ExecutingForm	OrderPopUp nicht da, dann umleiten zu Home
    if(localStorage.getItem("ExecutingForm") == null 
    || localStorage.getItem("ExecutingForm") == undefined 
    || localStorage.getItem("ExecutingForm") == ""
    || localStorage.getItem("ExecutingForm") !== "OrderPopUp") {

      if(localStorage.getItem("vas_customerId") !== null 
      || localStorage.getItem("vas_customerId") !== undefined) {
        Vas.GetView("CustomerCard", {Id:localStorage.getItem("vas_customerId")}, true);
      } else{
        Vas.GetView("Tariffing", null, true);
      }
    }
  }

  componentDidMount(){
      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);

      this.Request2.setAuth(false);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setApiUrl(Vas.ApiUrl);

      this.Request3.setAuth(false);
      this.Request3.setApiKey(Vas.ApiKey);
      this.Request3.setApiUrl(Vas.ApiUrl);

      if(localStorage.getItem("SelectedProductId") !== null 
        || localStorage.getItem("SelectedProductId") !== undefined 
        || localStorage.getItem("SelectedProductId") !== ""){

          this.ExistingConfirmationsModel.GetConfirmationsByCustomerId(localStorage.getItem("CustomerId"),null);

          this.ConfirmationsModel.GetConfirmationsByTicketId(localStorage.getItem("SelectedProductId"));
      }
  }

  Update(observer){
    let me = this;
    this.setState({},()=>{
      if(observer === "ConfirmationsByTicketId"){
        if (me.ConfirmationsModel.Confirmations.length > 0){
          let confirmationsArray = [];

          for(let i = 0; i < me.ExistingConfirmationsModel.Confirmations.length; i++){
            if(me.ExistingConfirmationsModel.Confirmations[i].IdentificationNumber === localStorage.getItem("ContractNumber")){
              if(me.ExistingConfirmationsModel.Confirmations[i].Id.indexOf("NoDocument") > -1 || me.ExistingConfirmationsModel.Confirmations[i].Id == ""){
                for(let j = 0; j < me.ConfirmationsModel.Confirmations.length; j++){
                  if(me.ConfirmationsModel.Confirmations[j].Name === me.ExistingConfirmationsModel.Confirmations[i].Name){
                    confirmationsArray.push(me.ConfirmationsModel.Confirmations[j]);
                    break;
                  }
                }
              }
            }            
          }

          me.setState({ConfirmationsRequired : true, 
            RequiredConfirmations : confirmationsArray},()=>{
            me.getConfirmationFields(confirmationsArray);
          });
        } else {

          me.setState({ allCertificates: true, 
              ConfirmationsRequired : false});
        }
      } else if (observer === "UploadConfirmation"){

      }

    });
  }

  getConfirmationFields(Data){//hole alle zum Kunden gehörenden Nachweise und prüfe, ob die benötigten bereits vorhanden sind
 
    if (!Data){
       Data = this.state.Confirmation; 
    }
    let existConfirm = [];
    existConfirm = this.state.existConfirm;
    if (Data){
        let count = Data.length;
        let filled = 0;

        Data.map(C =>{
          for (let i = 0; i< existConfirm.length; i++){
              if (existConfirm[i] === C["Name"]){
                  filled++;
              }
          }
        });
        if (filled === count){
            this.setState({ allCertificates: true,Confirmation:Data });
        } else {
            this.setState({ allCertificates: false,Confirmation:Data });
        }
    }
  }

  setVerificationMonths(minValue,maxValue){
    let monthsArr = [Vas.Resources.Calendar["January"],Vas.Resources.Calendar["February"],Vas.Resources.Calendar["March"],Vas.Resources.Calendar["April"],
      Vas.Resources.Calendar["May"],Vas.Resources.Calendar["June"],Vas.Resources.Calendar["July"],Vas.Resources.Calendar["August"],
      Vas.Resources.Calendar["September"],Vas.Resources.Calendar["October"],Vas.Resources.Calendar["November"],Vas.Resources.Calendar["December"]];
    let months = [];
    if(document.getElementById('VerificationYear')){
      if(document.getElementById('VerificationYear').selectedIndex > 0){
        if(maxValue){
          let year = Number($("#VerificationYear").val());
          if(year === minValue.year()){
            let firstMonth = minValue.month();
            let count =monthsArr.length;
            if(year === maxValue.year()){
              count = maxValue.month()+1;
            }
            for(let i = firstMonth; i<count;i++){
              months.push({Display:monthsArr[i],Key:i});
            }
  
          }
          
          else if(year === maxValue.year()){
            let lastMonth = maxValue.month();
            for(let i = 0; i<=lastMonth;i++){
              months.push({Display:monthsArr[i],Key:i});
            }
          }
          
          else{
            for(let i = 0; i<monthsArr.length;i++){
              months.push({Display:monthsArr[i],Key:i});
            }
          }
        }else{
          let year = Number($("#VerificationYear").val());
          if(year === minValue.year()){
            let firstMonth = minValue.month();
            for(let i = firstMonth; i<monthsArr.length;i++){
              months.push({Display:monthsArr[i],Key:i});
            }
  
          }
          else{
            for(let i = 0; i<monthsArr.length;i++){
              months.push({Display:monthsArr[i],Key:i});
            }
          }
        }
        
      }else{
        for(let i = 0; i<monthsArr.length;i++){
          months.push({Display:monthsArr[i],Key:i});
        }
      }
    }else{
      for(let i = 0; i<monthsArr.length;i++){
        months.push({Display:monthsArr[i],Key:i});
      }
    }
    
    return months;
  }

  getUploadFileds(C){// lege Felder für das hochladen eines Nachweises 

      let from = <td></td>;
      let to =<td></td>;
      let id =<td></td>;
      let downloadDocumentButton = <div></div>;

      let btoUploadCertificate = true;

      $('#uploadFields').removeClass().addClass('uploadFieldsVisible');

      let minValue = DateTimeHelper.StringToDate(localStorage.getItem("ContractOverviewContractStart"),true,localStorage.getItem('vas_language'));

      if (C["DateFrom"] === true){
          from = (<td><DateField
            AppURL={Vas.ApplicationUrl}
            Language={localStorage.getItem("vas_language")}
            Width={220}
            Editable={true}
            IsRequired={true}
            Id={"CertificateStart"}
            Label={Vas.Resources.Labels["ValidFrom"]+ '*'}
            OnBlur={()=>{ this.setState({ CertificateStart: $("#CertificateStart").val() });}}
            MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
            FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
            /></td>);
      }

      if (C["DateTo"] === true){
        if(C["MaxAge"] > 0){
          if(C["Name"].indexOf("Ermäßigung") > -1){

            /*to = (<td><DateField
              AppURL={Vas.ApplicationUrl}
              Language={localStorage.getItem("vas_language")}
              Width={220}
              Editable={true}
              IsRequired={true}
              Id={"CertificateEnd"}
              Label={Vas.Resources.Labels["ValidTo"]+ '*'}
              OnBlur={()=>{ 
                let curDate = DateTimeHelper.StringToDate($("#CertificateEnd").val(),false,localStorage.getItem('vas_language'),false);
                curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                curDate = DateTimeHelper.FormatToShortDateString(curDate);
                
                this.setState({ CertificateEnd: curDate });}} 
              MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
              MaxValue={moment([minValue.year() + 1,minValue.month(),minValue.date()])}
              FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
              ShowDay={false}
              /></td>);*/
            let countYears = 1 ;
            if(minValue.month() > 0){
              countYears = 2;
            }
            let maxValue = null;
            if(this.Customer.DateOfBirth.length > 0){
              
              let age = moment().diff(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
              let maxAge = C["MaxAge"];
              //countYears = maxAge >= age ? maxAge-age : 0;
              maxValue = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
              if(maxValue.year() === minValue.year()){
                countYears = 1;

              }else{
                if(maxValue.isAfter(moment([minValue.year() + 1,minValue.month(),minValue.date()]))){
                  maxValue = moment([minValue.year() + 1,minValue.month()-1,minValue.date()]);
                 }
              }
              
            }else{
              maxValue = moment([minValue.year() + 1,minValue.month() -1,minValue.date()]);
            }
            
            let years= [];
            let startYear = minValue.year();
            for(let i = 0; i<countYears; i++){
              years.push({Display:startYear + i, Key: startYear + i});
            }
            to = (<td><table>
              <tbody>
                <tr>
                  <td>
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <SelectField
                      Id={"VerificationYear"} 
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["Year"]+ "*"}
                      Data={ years }
                      OnChange={()=>{
                        this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                          if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                            let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                            curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                            curDate = DateTimeHelper.FormatToShortDateString(curDate);
                            
                            this.setState({ CertificateEnd: curDate });
                            this.UploadCertificateRef.current.setState({usable:true});
                          }
                        });
                        this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue,maxValue)});
                      }}
                    />
                  </td>
                  <td>
                    <SelectField
                      Id={"VerificationMonth"} 
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["Month"]+ "*"}
                      ref={this.VerificationMonthRef}
                      Data = {this.setVerificationMonths(minValue)}
                      OnChange={()=>{
                        this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                          if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                            let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                            curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                            curDate = DateTimeHelper.FormatToShortDateString(curDate);
                            
                            this.setState({ CertificateEnd: curDate });
                            this.UploadCertificateRef.current.setState({usable:true});
                          }
                        });
                      }}
                    />
                  </td>
                </tr>
                
              </tbody>
            </table></td>);

          }else if(C["Name"] === "vsl. Ende der Ausbildung"){
            let countYears = 10 ;
            let maxValue = null;
            if(this.Customer.DateOfBirth.length > 0){
              let age = moment().diff(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
              let maxAge = C["MaxAge"];
              countYears = maxAge >= age ? maxAge-age : 0;
              maxValue = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
            }
            
            
            let years= [];
            let startYear = minValue.year();
            for(let i = 0; i<countYears; i++){
              years.push({Display:startYear + i, Key: startYear + i});
            }
            to = (<td><table>
              <tbody>
                <tr>
                  <td>
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <SelectField
                      Id={"VerificationYear"} 
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["Year"]+ "*"}
                      Data={ years }
                      OnChange={()=>{
                        this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                          if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                            let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                            curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                            curDate = DateTimeHelper.FormatToShortDateString(curDate);
                            
                            this.setState({ CertificateEnd: curDate });
                            this.UploadCertificateRef.current.setState({usable:true});
                          }
                        });
                        this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue,maxValue)});
                      }}
                    />
                  </td>
                  <td>
                    <SelectField
                      Id={"VerificationMonth"} 
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["Month"]+ "*"}
                      ref={this.VerificationMonthRef}
                      Data = {this.setVerificationMonths(minValue)}
                      OnChange={()=>{
                        this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                          if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                            let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                            curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                            curDate = DateTimeHelper.FormatToShortDateString(curDate);
                            
                            this.setState({ CertificateEnd: curDate });
                            this.UploadCertificateRef.current.setState({usable:true});
                          }
                        });
                      }}
                    />
                  </td>
                </tr>
                
              </tbody>
            </table></td>);
          }
          else{
            let countYears = 10 ;
            let maxValue = null;
            if(this.Customer.DateOfBirth.length > 0){
              let age = moment().diff(DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
              let maxAge = C["MaxAge"];
              countYears = maxAge >= age ? maxAge-age : 0;
              maxValue = DateTimeHelper.StringToDate(this.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
            }else{

            }
            to = (<td><DateField
              AppURL={Vas.ApplicationUrl}
              Language={localStorage.getItem("vas_language")}
              Width={220}
              Editable={true}
              IsRequired={true}
              Id={"CertificateEnd"}
              Label={Vas.Resources.Labels["ValidTo"]+ '*'}
              OnBlur={()=>{ this.setState({ CertificateEnd: $("#CertificateEnd").val() });}} 
              MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
              MaxValue={maxValue ? moment([maxValue.year(),maxValue.month(),maxValue.date()]).subtract(1,"day") : null}
              FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
              /></td>);
          }
        }else{
          if(C["Name"].indexOf("Ermäßigung") > -1){
            to = (<td><DateField
              AppURL={Vas.ApplicationUrl}
              Language={localStorage.getItem("vas_language")}
              Width={220}
              Editable={true}
              IsRequired={true}
              Id={"CertificateEnd"}
              Label={Vas.Resources.Labels["ValidTo"]+ '*'}
              OnBlur={()=>{ 
                let curDate = DateTimeHelper.StringToDate($("#CertificateEnd").val(),false,localStorage.getItem('vas_language'),false);
                curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                curDate = DateTimeHelper.FormatToShortDateString(curDate);
                
                this.setState({ CertificateEnd: curDate });}} 
              MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
              MaxValue={moment([minValue.year() + 1,minValue.month(),minValue.date()])}
              FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
              ShowDay={false}
              /></td>);

          }
          else if(C["Name"] === "vsl. Ende der Ausbildung"){
            
            let years= [];
            let startYear = minValue.year();
            for(let i = 0; i<10; i++){
              years.push({Display:startYear + i, Key: startYear + i});
            }
            to = (<td><table>
              <tbody>
                <tr>
                  <td>
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <SelectField
                      Id={"VerificationYear"} 
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["Year"]+ "*"}
                      Data={ years }
                      OnChange={()=>{
                        this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                          if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                            let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                            curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                            curDate = DateTimeHelper.FormatToShortDateString(curDate);
                            
                            this.setState({ CertificateEnd: curDate });
                            this.UploadCertificateRef.current.setState({usable:true});
                          }
                        });
                        this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue)});
                      }}
                    />
                  </td>
                  <td>
                    <SelectField
                      Id={"VerificationMonth"} 
                      AppURL={Vas.ApplicationUrl}
                      me={this}
                      IsRequired={true}
                      Label={Vas.Resources.Labels["Month"]+ "*"}
                      ref={this.VerificationMonthRef}
                      Data = {this.setVerificationMonths(minValue)}
                      OnChange={()=>{
                        this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                          if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                            let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                            curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                            curDate = DateTimeHelper.FormatToShortDateString(curDate);
                            
                            this.setState({ CertificateEnd: curDate });
                            this.UploadCertificateRef.current.setState({usable:true});
                          }
                        });
                      }}
                    />
                  </td>
                </tr>
                
              </tbody>
            </table></td>);
          }
          else{
            to = (<td><DateField
              AppURL={Vas.ApplicationUrl}
              Language={localStorage.getItem("vas_language")}
              Width={220}
              Editable={true}
              IsRequired={true}
              Id={"CertificateEnd"}
              Label={Vas.Resources.Labels["ValidTo"]+ '*'}
              OnBlur={()=>{ this.setState({ CertificateEnd: $("#CertificateEnd").val() });}} 
              MinValue={moment([minValue.year(),minValue.month(),minValue.date()])}
              FalseMinDateText={Vas.Resources.Labels["FalseDate"]}
              /></td>);
          }
        }
      }

      if (C["IdentificationNumber"] === true){
          id = (<td colSpan={2}>
            <TextField
              AppURL={Vas.ApplicationUrl}
              Width={220}
              Id="IDField"
              Editable={true}
              IsRequired={true}
              Label={Vas.Resources.Labels["IdentificationNumber"]+ '*'}
              OnBlur={()=>{ this.setState({ IdentificationNumber: $("#IDField").val() });}} />
          </td>);
      }

      if(C["Name"].indexOf("Ermäßigung") > -1){
        downloadDocumentButton = (<div><ExtendedButton
            Id={"DownloadDocument"}
            Usable={true}
            Text={ Vas.Resources.Labels["ReductionDocumentDownload"] }
            Width={170}
            Float={"left"}
            OnClick={() => { window.open(Vas.ApplicationUrl+"/ErmäßigungABO.pdf") }} /></div>);
      }

      let FileText;

      let btoChooseIcon = <ExtendedButton 
      Id={"btoChoose"} 
      Usable={true} 
      Text={<Icon  
        Name={"Upload"} 
        Size={18} 
        Color={"black"} 
        PaddingLeft={'6px'} 
        PaddingTop={'0px'} 
        Tooltip={Vas.Resources.Tooltips["ChooseDocument"]}
        OnClick={()=>{$("#fileUpload").trigger('click');}} />} 
      Width={30} 
      Height={30} 
      Type={"Round"} />;

      if(Vas.isIE) {
        btoChooseIcon = <ExtendedButton 
          Id={"btoChoose"} 
          Usable={true} 
          Text={<Icon  
            Name={"Upload"} 
            Size={18} 
            Color={"black"} 
            PaddingLeft={'6px'} 
            PaddingTop={'0px'} 
            Tooltip={Vas.Resources.Tooltips["ChooseDocument"]} />} 
          Width={30} 
          Height={30} 
          Type={"Round"} />;
      }
    
      let btoChooseText = "";
      if(this.IconConfig.ShowIcons === false){
        btoChooseIcon="";
        btoChooseText = <ExtendedButton
          Id={"btoChoose"}
          Usable={true}
          Text={Vas.Resources.Labels["ChooseDocument"]}
          Width={150}
          OnClick={()=>{$("#fileUpload").trigger('click');}}/>;

        if(Vas.isIE) {
          btoChooseText = <ExtendedButton
            Id={"btoChoose"}
            Usable={true}
            Text={Vas.Resources.Labels["ChooseDocument"]}
            Width={150}/>;
        }
      }

      let hint = "";
      if(C["Description"].length > 0){
        hint = <div><b>{Vas.Resources.Titles["Note"]}: </b><i>{C["Description"]}</i></div>;
      }

      let classNameStandartControl = "standartInput";
      let additionTextField = <td></td>;
      let additionButton = <td></td>;

      if(this.UploadConfig.ShowStandardControl === false){
        classNameStandartControl = "inputfile";
        additionTextField = <td style={{ width:'170px' }}>
        <TextField
          ref={this.FileText }
          AppURL={Vas.ApplicationUrl}
          Width={170}
          Id="FileText"
          Value={this.state.fileName}
          Editable={false}
          Label={Vas.Resources.Labels["File"]+ '*'} />
      </td>;
        additionButton = <td colSpan={2}>
        <label htmlFor="fileUpload">
            {btoChooseText}
            
            </label>
        </td>;
      }

      ReactDOM.render(
        <table>
          <tbody>
            <tr>
              <td colSpan={2}>
                <TextField
                  AppURL={Vas.ApplicationUrl}
                  Value={C["Name"]}
                  Width={220}
                  Id={"Text"}
                  Editable={false}
                  Label={Vas.Resources.Labels["CertificationType"]} />
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <div id={"certificationDescription"} style={{ margin: '10px' }}>{hint}</div>

                { downloadDocumentButton }
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className={"btoTd"} style={{paddingTop:'25px'}}>
                        <input
                          id="fileUpload"
                          type="file"
                          name="files[]"
                          className={classNameStandartControl}
                          onChange={(event)=>{this.storeFile(event,C);}}
                          accept="image/bmp,image/png,image/jpeg,image/jpg, image/gif,application/pdf" />
                        <label htmlFor="fileUpload">{btoChooseIcon}</label>
                      </td>
                      {additionTextField}
                    </tr>
                    <tr>
                      {additionButton}
                      
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              {from}
                      
            </tr>
            <tr>
              {to}
            </tr>
            <tr>
              {id}
            </tr>
            <tr>
              <td colSpan={2}><br />
                <div id={"validDocumentFormat"}>
                  {Vas.Resources.Labels["ValidDocumentFormat"]}
                  <br /><br />{Vas.Resources.Labels["ValidDocumentSize"]}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <ExtendedButton
                  Id={"UploasdCertificateButton"}
                  Usable={btoUploadCertificate}
                  Text={Vas.Resources.Labels["UploadCertificate"]}
                  Float={"left"}
                  Width={170}
                  OnClick={()=>{this.uploadDocument(C);}}
                  ref={this.UploadCertificateRef}
                   />   
              </td>
            </tr> 
          </tbody>
        </table>
          , document.getElementById('uploadFields'));
          this.setState({ FileText:FileText });
  }

  storeFile(event,C){//Speichere Dokument in der Anwendung
      let type = event.target.files[0].type;
      if (((type.slice(0,5) === "image") || (type === "application/pdf")) && (event.target.files[0].size > 0) ){

        let maxFileSize = 10 * 1024 * 1000;

            if (event.target.files[0].size > maxFileSize){
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.Labels["DocumentSizeInvalid"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));

                  this.FileText.current.setState({ Value:'', TextTooltip : '' });
                  this.setState({ files:null, fileName:''});
            } else {

              let original = event.target.files[0].name;
              let name = event.target.files[0].name.split(".");

              if(name.length === 2){
                let length = name[0].length;
                let showName = name[0];
                let showType = "." + name[1];
                if(length > 20){
                showName = name[0].substr(0,19) + "...";
                }
                original = showName + showType;
              }
              
              if(this.UploadConfig.ShowStandardControl === false){
                if (this.FileText.current){
                    this.FileText.current.setState({ Value:original, TextTooltip : event.target.files[0].name });
                }
              }
                this.setState({ files:event.target.files, fileName:event.target.files[0].name },()=>{
                    this.getUploadFileds(C);
                });
            } 
      }else{
        if(event.target.files[0].size === 0){
          ReactDOM.render(<MessageBox 
            AppURL={Vas.ApplicationUrl} 
            Message={Vas.Resources.Labels["FileNoContent"]} 
            Title={Vas.Resources.Titles["Note"]} />
              , document.getElementById('messageContainer'));
        }
      }
  }

  //TODO: Probieren, ob das so geht Dokumente nach Klick auf Dokument hochladen sofort hochladen. Nicht zusammen unter UploadDocuments
  //Geht irgendwie nicht. Warum auch immer!!! Vorlage siehe VerificationUpload

  uploadDocument(field){//lade Nachweis in die Datenbank hoch

      let start = DateTimeHelper.StringToDate(localStorage.getItem("ContractOverviewContractStart"),true,localStorage.getItem('vas_language'));
      $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
      

      let ok = false;
      let falseDate = false;
      
      let data = {
        file : null,
        confirmationId : '',
        datefrom : null,
        dateto : null,
        identificationNumber : null
      };

      if (this.state.files){
          for (var i = 0; i < this.state.files.length; i++) {
              data.file = this.state.files[i];

              ok = true;
          }
      }

      data.confirmationId = field.Ident;

      if (ok === true){
          if (field.DateFrom === true){
              if (this.state.CertificateStart){
                  let certStart = DateTimeHelper.StringToDate(this.state.CertificateStart,false,localStorage.getItem('vas_language'));

                  if (certStart.isSameOrBefore(start, 'day') === true){
                      data.datefrom = moment([certStart.year(),certStart.month(),certStart.date()]).format("YYYY-MM-DD T 00:00:00");

                      ok = true; 
                  } else {
                      ok = false;
                      falseDate = true;
                  }
              } else {
                  ok = false;
              }
          } else {
              //formData.append("datefrom", null);
          }
      }
      
      if (ok === true){

          if(field.Name == "Ermäßigung ab 16" && field.DateTo === false){

            let contractStart = DateTimeHelper.StringToDate(localStorage.getItem("ContractOverviewContractStart"),true,localStorage.getItem('vas_language'));

            data.dateto = moment([contractStart.year() + 1,contractStart.month(),contractStart.date()]).format("YYYY-MM-DD T 00:00:00");

            ok = true;
          } else if (field.DateTo === true){
              if (this.state.CertificateEnd){
                 
                  let certEnd =DateTimeHelper.StringToDate(this.state.CertificateEnd,false,localStorage.getItem('vas_language'));

                  if (certEnd.isSameOrAfter(start,'day') === true){
                      data.dateto = moment([certEnd.year(),certEnd.month(),certEnd.date()]).format("YYYY-MM-DD T 00:00:00");

                      ok = true;
                  } else {
                      ok = false;
                      falseDate = true;
                  }
              } else {
                  ok = false;
              }
          } else {
              //formData.append("dateto", null);
          }
      }
      
      if (ok === true){
          if (field.IdentificationNumber === true){
              if (this.state.IdentificationNumber){
                  data.identificationNumber = this.state.IdentificationNumber;

                  ok = true;
              } else {
                  ok = false;
              }
          } else {
              //formData.append("identificationNumber", null);
          }
      }
         
      if (ok === true){
          
          let curr = [];
          curr = this.state.Files;
          curr.push(data);

          let exist = [];
          exist = this.state.existConfirm;
          exist.push(field.Name);

          this.setState({ existConfirm:exist,Files:curr });
          this.setState({ CertificationType:null,CertificateStart:null,CertificateEnd:null,IdentificationNumber:null,requiredFieldsCertificate:null, files:null, fileName:'' });
          $('#uploadFields').removeClass().addClass('uploadFields');
          ReactDOM.unmountComponentAtNode(document.getElementById('uploadFields'));
          $("#LoadingIconPopUp").removeClass().addClass('hide');
          this.getConfirmationFields();
      } else {
          $("#LoadingIconPopUp").removeClass().addClass('hide');
          if (falseDate === true){
              ReactDOM.render(<MessageBox
                AppURL={Vas.ApplicationUrl}
                Title={Vas.Resources.Titles["Note"]}
                Message={Vas.Resources.Labels["FalseDate"]} />, document.getElementById('messageContainer'));
          } else {
              ReactDOM.render(<MessageBox
                AppURL={Vas.ApplicationUrl}
                Title={Vas.Resources.Titles["Note"]}
                Message={Vas.Resources.Labels["NotAllFields"]} />, document.getElementById('messageContainer'));
          }
      }

      let customerId = localStorage.getItem("CustomerId");
      this.UploadingConfirmationsModel.UploadConfirmation(customerId,data.confirmationId,data.datefrom, data.dateto,data.identificationNumber,[data.file]);
  }

  FinishVerificationReupload(){

      localStorage.removeItem("CustomerId");
      localStorage.removeItem("ContractNumber");
      localStorage.removeItem("ExecutingForm");

      Vas.GetView("OrderSuccess",[],false);
  }

 render()
  {

    let Data ='';
    if (!this.state.RequiredConfirmations){
      Data = this.state.Confirmation; 
    }else{
      Data =this.state.RequiredConfirmations;
    }
    let existConfirm = [];
    existConfirm = this.state.existConfirm;

    if(Data){

      let perso;
      let bank;
      let restData = [];

      Data.forEach(function(value){
        if(value.Name == "Personalausweis"){
          perso = value;
        }
        else if(value.Name == "Bankverbindungsnachweis"){
          bank = value;
        } else{
          restData.push(value);
        }
      });

      //Data leeren
      Data = [];

      //Perso und Bankverbindung in Data schreiben, wenn vorhanden
      if(perso != undefined){
        Data.push(perso);
      }

      if(bank != undefined){
        Data.push(bank);
      }

      //restlichen Nachweise in Data schreiben
      restData.forEach(function(value){
        Data.push(value);
      });

      let j = 0;

      if(Data != undefined && existConfirm.length == Data.length){
        if($("#FinishVerificationReuploadContainer") !== null || $("#FinishVerificationReuploadContainer") !== undefined){
          $("#FinishVerificationReuploadContainer").removeClass().addClass("visible");
        }
      }

      return (<div className="VerificationReuploadContainer">
        <div className={"form verificationReuploadForm"}>
          <table style={{ width: '360px'}}>
            <thead>
              <tr>
                <th colSpan={2}><h2 style={{ width: '320px'}}>{Vas.Resources.Labels["NecessaryVerificationsForContract"] + " " + localStorage.getItem("ContractNumber") }</h2></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2}>
                  <div style={{ width: '320px'}}>
                    { Vas.Resources.Labels["UploadVerificationsForContractHint"] }
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan='2'>
                  <br /><div className={"ConfirmationLabel"}>{Vas.Resources.Labels["RequiredField"]}</div><br />
                </td>
                <td></td>
              </tr>
              <tr>
                <td id={"confirmationFields"}>
                <table style={{ margin: 'auto' }}>
                  <tbody>
                    {
                          Data.map(C =>{

                              j++;

                              let exist = false;
                              for (let i = 0; i< existConfirm.length; i++){
                                  if (existConfirm[i] === C["Name"]){
                                      exist = true;
                                  }
                              }
                              
                              if (exist === true){
                                  return (
                                    <tr key={C["Name"]}>
                                      <td>
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td style={{ width:'200px' }}>
                                                <div className={"ConfirmationLabel"}>{C["Name"]}</div>
                                              </td>
                                              <td>
                                                <Icon
                                                  Name={"Done"}
                                                  Size={24}
                                                  Color={"green"}
                                                  Align={"left"}
                                                  Tooltip={Vas.Resources.Tooltips["StillUploaded"]} />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  );
                              } else {
                                let notUploaded = <Icon
                                  Name={"Warning"}
                                  Size={24}
                                  Color={"red"}
                                  Align={"left"}
                                  OnClick={()=>{this.getUploadFileds(C);}}
                                  Tooltip={Vas.Resources.Tooltips["NotUploaded"]} />;
                                if(this.IconConfig.ShowIcons === false){
                                      notUploaded = <ExtendedButton
                                      Id={"btoChoose_" + j}
                                      Usable={true}
                                      Text={Vas.Resources.Labels["UploadDocument"]}
                                      Width={150}
                                      OnClick={()=>{this.getUploadFileds(C);}}
                                  />;
                                }
                                  return (
                                    <tr key={C["Name"]}>
                                      <td>
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td style={{ width:'200px' }}>
                                                <div className={"ConfirmationLabel"}>{C["Name"]}</div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                {notUploaded}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  );
                              }
                          }) 
                          }
                  </tbody>
                </table>
                </td>
              </tr>
              <tr>
                <td
                  className={"uploadFields"}
                  id={"uploadFields"} >
                </td>
              </tr>
            </tbody>
          </table>
          <div id={"FinishVerificationReuploadContainer"} className={"hidden"}>
            <div style={{ width: '320px', marginBottom: '15px' }}>
              { Vas.Resources.Labels["AllVerificationsUploadedSuccessfully"] }
            </div>

            <ExtendedButton
              Id={"FinishVerificationReupload"}
              Usable={true}
              Text={ Vas.Resources.Labels["ContractOverView"] }
              Width={200}
              OnClick={() => { this.FinishVerificationReupload(); }} />
          </div>
        </div>
      </div>);
    } else {
      return( <table></table>);
    }
  }
}
export default VerificationReupload;